import React, { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Button,
  IconButton,
  Typography,
  Card,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  CircularProgress,
  Autocomplete,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Helper from '../../utility/helper';
import { createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import RouteConstants from '../../constants/routeConstants';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import DataList from './dataList/dataList';
import ParticipantAutoList from '../../sharedcomponents/participantAutoList/participantAutoList';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import AppConstants from '../../constants/appConstants';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import Title from '../../sharedcomponents/title/title';
import { RouterPrompt } from '../../router/routerPrompt';
import { useHistory, generatePath } from 'react-router-dom';
import UserListDialog from './userListDialog';
const theme = createTheme();
const loader = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
};
const useStyles = makeStyles(() => ({
  listItemContent: {
    padding: theme.spacing(1, 0),
  },
  rowContent: {
    textAlign: 'center',
  },
  paperContent: {
    boxShadow: 'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
    borderRadius: theme.spacing(2),
    padding: theme.spacing(1),
    backgroundColor: '#fff',
    border: '1px solid #efefef',
  },
  buttonContainer: {
    marginTop: theme.spacing(2),
  },
}));

const KeyContacts = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const [moduleName, setModuleName] = useState('');
  const [selectedUser, setSelectedUser] = useState([]);
  const [isContact, setIsContact] = useState(false);
  const [isEmail, setIsEmail] = useState(false);
  const [userList, setUserList] = useState([]);
  const [contactList, setContactList] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [listData, setListData] = useState([]);
  const [snackBarProps, setSnackBarProps] = React.useState({
    openSnack: false,
    variant: 'error',
    message: '',
  });
  const [loading, setLoading] = useState(false);
  const [dirty, setDirty] = useState(false);
  const [disBtn, setDisBtn] = useState(true);
  const [openAddParticipantDialog, setOpenAddParticipantDialog] = useState(false);
  const [selectedViewParticipantData, setSelectedViewParticipantData] = useState([]);
  const [keyContactPersonData, setKeyContactPersonData] = useState([]);


  const handleAdd = () => {
    // console.log("selectedUser", selectedUser);
    if (moduleName === "") {
      setSnackBarProps({
        openSnack: true,
        variant: 'error',
        message: 'Please Enter Module Name',
      });
      return;
    } else if (selectedUser === undefined || selectedUser.length === 0) {
      setSnackBarProps({
        openSnack: true,
        variant: 'error',
        message: 'Please Select Participnat',
      });
      return;
    } else if (editIndex !== null) {
      const updatedList = [...contactList];
      // console.log("updatedList",updatedList,"editIndex",editIndex);
      const participantIds =
        selectedUser.length > 0
          ? selectedUser.map((ids) => ids.userID).join(',')
          : '';
      updatedList[editIndex] = {
        moduleName: moduleName.trim(),
        iDs: participantIds,
        user: selectedUser.name,
        email: selectedUser.email,
        userID: selectedUser.userID,
        keyContactPersonDetails: selectedUser,
        isContact,
        isEmail,
        order: editIndex
      };
      setContactList(updatedList);
      setEditIndex(null);
      setSelectedUser([]);
    } else {
      const participantIds =
        selectedUser.length > 0
          ? selectedUser.map((ids) => ids.userID).join(',')
          : '';
      const newUser = {
        moduleName: moduleName.trim(),
        iDs: participantIds,
        user: selectedUser.name,
        email: selectedUser.email,
        userID: selectedUser.userID,
        keyContactPersonDetails: selectedUser,
        isContact,
        isEmail,
        order: contactList.length + 1
      };
      setContactList([...contactList, newUser]);
      reset();
    }
    setModuleName('');
    setSelectedUser([]);
    setIsContact(false);
    setIsEmail(false);
    setDirty(true)
    setDisBtn(false)
  };

  const reset = () => {
    setModuleName('');
    setSelectedUser([]);
    setIsContact(false);
    setIsEmail(false);
    setDirty(false);
    setDisBtn(false);
  }

  useEffect(() => {
    getlist();
  }, [contactList])



// console.log("contactList",contactList);
  const getlist = () => {
    let keyData = [];
    
    if (contactList && contactList.length > 0) {
      contactList.sort( function ( a, b ) { return a.order - b.order; } );
      // console.log("contactList123",contactList);

      let names= [];
      contactList.map((item) => {
        if(item.keyContactPersonDetails && item.keyContactPersonDetails){ 
          item.keyContactPersonDetails.map((val) => {
            names.push(val.participant ? val.participant.replace(',', ' ') : val.name.replace(',', ' '))
          })
        }
        keyData.push({
          actualData: item,
          row: [
            {
              label: 'black',
              key: 'keyContactID',
              keyContactID: item.keyContactID,
              width: '0.04',
              inColumn: true,
              alignCenter: true,
            }, 
            {
              label: 'Module',
              key: 'module',
              module: item.moduleName,
              width: '0.2',
              inColumn: true,
            },
            {
              label: 'participant',
              key: 'participant',
              participant: names.toString().replace(',', ', '),
              width: '0.4',
              showLabel: false,
              inColumn: true,              
            },
            {
              label: 'Is Contacts',
              key: 'contact',
              contact: item.isContact ? "Yes" : "No",
              width: '0.15',
              inColumn: true,
              alignCenter: true
            },
            {
              label: 'Is Emails',
              key: 'email',
              email: item.isEmail ? "Yes" : "No",
              width: '0.15',
              inColumn: true,
              alignCenter: true
            },
            {
              label: 'Action',
              key: 'participants',
              participants: 'Participants',
              count:
                item.keyContactPersonDetails && item.keyContactPersonDetails != null
                  ? item.keyContactPersonDetails.length
                  : 0,
              width: '0.02',
              inColumn: true,
            },
            {
              label: 'Action',
              key: 'edit',
              edit: 'Edit',
              width: '0.02',
              inColumn: true,
            },
            {
              label: 'Action',
              key: 'delete',
              delete: 'Delete',
              width: '0.02',
              inColumn: true,
            },
          ],
          selected: false,
        })
        names= []
      })
    }
    setListData(keyData)
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    const userInfo = Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    // console.log("contactList", contactList);
     
      let keyCP = []
      if (contactList && contactList.length > 0) {
        contactList.map((val) => {
          keyCP.push({
            keyContactID: val.keyContactID ? val.keyContactID : 0,
            moduleName: val.moduleName,
            iDs: val.iDs,
            userID: val.userID,
            isEmail: val.isEmail,
            isContact: val.isContact,
            order: val.order
          })
        })
      }
      const KeycontactsData =
      {
        keyContactID: 0,
        eventID: eventInfo.eventID,
        createdBy: userInfo.userID,
        keyContactPerson: keyCP
      }

      ApiHelper.post(APIURLConstants.ADD_UPDATE_KEY_CONTACT, KeycontactsData)
        .then((res) => {
          if (res) {
            setDirty(false)
            getKeyContacts()
            setSnackBarProps({
              openSnack: true,
              variant: 'success',
              message: 'Record added successfully',
            });
          }
        })
        .catch((error) => {
          console.log('Error : ', error);
          setSnackBarProps({
            openSnack: true,
            variant: 'error',
            message: 'Error while creating request',
          });
        }); 

  };
  useEffect(() => {
    const gEventInfo = Helper.getStorage('eventInfo');
    ApiHelper.get(
      APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
    ).then((res) => {
      if (res.data.rows) {
        const participants = res.data.rows.filter(
          (participant) =>
            AppConstants.EVENT_ROLES_VALUES.indexOf(
              participant.roleName
            ) !== -1
        );
        setUserList(participants);
      }
    });
    getKeyContacts()
    reset();
  }, []);
  const getKeyContacts = () => {
    const gEventInfo = Helper.getStorage('eventInfo');
    setLoading(true)
    ApiHelper.get(
      APIURLConstants.GET_KEY_CONTACTS(gEventInfo.eventID)
    ).then((res) => {
      if (res.data.keyContactPersons && res.data.keyContactPersons.length > 0) {
        let data = []
        setLoading(false)
        res.data.keyContactPersons.map((item, index) => {
          const participantIds =
            item.keyContactPersonDetails.length > 0
              ? item.keyContactPersonDetails.map((ids) => ids.userID).join(',')
              : '';
          data.push({
            keyContactID: item.keyContactID,
            moduleName: item.moduleName,
            user: item.participant,
            iDs: participantIds,
            email: item.email,
            userID: item.userID,
            isContact: item.isContact,
            isEmail: item.isEmail,
            keyContactPersonDetails: item.keyContactPersonDetails,
            order: index+1
          })
        })
        setContactList(data);
      } else {
        setLoading(false)
      }
    }).catch((err) => {
      console.log(err);
      setLoading(true)
    })

  }
  const deleteKeyContacts = (item, index) => {
    const updatedList = [...contactList];
    updatedList.splice(index, 1);
    setContactList(updatedList);
    setModuleName('');
    setSelectedUser([]);
    setIsContact(false);
    setIsEmail(false);
    setDirty(true)
    setDisBtn(false)
  }
  const editKeyContacts = (item, index) => {
    // console.log(index, item);
    setEditIndex(index);
    const selectedItem = contactList[index];
    // const filteredParticipants = userList.filter((val) => val.userID === selectedItem.userID)
    let filteredParticipant = userList.filter(
      (x) =>
        (selectedItem.keyContactPersonDetails && selectedItem.keyContactPersonDetails.length > 0) && selectedItem.keyContactPersonDetails
          .map((y) => y.userID)
          .includes(x.userID)
    );
    // console.log("filteredParticipant", filteredParticipant);
    setModuleName(selectedItem.moduleName);
    setSelectedUser(filteredParticipant);
    setIsContact(selectedItem.isContact);
    setIsEmail(selectedItem.isEmail);
    setDirty(true)
  }
  const changeParticipant = async (participant) => {
    setDirty(true)
    setSelectedUser(participant)
  }
  const handleCancel = () => {
    const eventInfo = Helper.getStorage('eventInfo');
    setDirty(false)
    const path = generatePath(RouteConstants.EVENT_DETAIL, {
      eventID: eventInfo.eventID,
    });
    history.push({
      pathname: path
    });
  }
  const onModuleNameChange = (e) => {
    if (e.target.value.length < 50) {
      setModuleName(e.target.value);
    }
  }
  const onDragEnd = ({ destination, source }) => {
    if (!destination) return;
    reorder(source.index, destination.index);
  };
  const reorder = (startIndex, endIndex) => {
    const newModuleList = [...listData];
    const [removed] = newModuleList.splice(startIndex, 1);
    newModuleList.splice(endIndex, 0, removed);
    let contactsData = []
    newModuleList.map((val, index) => {
      contactsData.push(val.actualData)
      return val.actualData.order = index + 1
    })
    // console.log("newModuleList",newModuleList,contactsData);
     
    setContactList(contactsData)
    setListData(newModuleList);
  };
  
  const handleViewParticipants = (item) => {
    // console.log("item",item.actualData);
    setKeyContactPersonData(item.actualData)
    let newFilterParticipant = userList.filter(function (cv) {
      return item && item.actualData.keyContactPersonDetails.find(function (e) {
        return e.userID == cv.userID;
      });
    });
    setSelectedViewParticipantData(newFilterParticipant);
    setOpenAddParticipantDialog(true);
  }
  const handleCloseViewInstruction = () => {
    setOpenAddParticipantDialog(false);
    setSelectedViewParticipantData([]);
    setKeyContactPersonData([])
  }
  const deleteParticipants = (selectedUsers) => {
    // console.log(selectedUsers);
    if (selectedUsers.length === 0) {
      setSnackBarProps({
        snackBarProps,
        openSnack: true,
        variant: 'error',
        message: 'Please select participants first',
      });
    } else {
      let filteredParticipant
      let filteredParticipantIds = []
      if (keyContactPersonData && keyContactPersonData.keyContactPersonDetails.length > 0) {
        filteredParticipant = keyContactPersonData.keyContactPersonDetails.filter(
          (x) =>
            (selectedUsers && selectedUsers.length > 0) && selectedUsers
              .map((y) => y)
              .includes(x.userID)
        );
      }
      if (filteredParticipant && filteredParticipant.length > 0) {
        filteredParticipant.map((val) => {
          filteredParticipantIds.push(val.keyContactPersonID)
        })
      }

      const obj = {
        userIDs: selectedUsers.toString(),
        keyContactPersonIDs: filteredParticipantIds.toString()
      }
      return ApiHelper.post(APIURLConstants.DELETE_KEY_CONTACTS, obj)
        .then((result) => {
          if (result.data) {
            setSnackBarProps({
              openSnack: true,
              variant: 'success',
              message: 'Participants deleted successfully.',
            });
            getKeyContacts();
            setOpenAddParticipantDialog(false);
          } else {
            setSnackBarProps({
              openSnack: true,
              variant: 'error',
              message: 'Something went wrong.',
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });

    }
  }

  const renderAutocomplete = () => (
    <Autocomplete
      multiple
      id="size-small-standard-multi"
      size="small"
      options={userList}
      getOptionLabel={(option) => option.name}
      value={selectedUser && selectedUser}
      onChange={(event, newValue) => {
        changeParticipant(newValue);
      }}
      renderInput={(params) => (
        <TextField {...params} placeholder="Participants" />
      )}
    />
  );

  return (
    <Box sx={{ width: '100%' }}>
      <Box className="contentBox">
        <Box>
          <Title title="Event Key Contacts" />
        </Box>
        <Card className={classes.paperContent}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                required={true}
                size='small'
                label="Module Name"
                variant="outlined"
                value={moduleName}
                onChange={(e) => {
                  onModuleNameChange(e)
                  setDirty(true)
                }
                }
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              {editIndex !== null && selectedUser ? renderAutocomplete() : renderAutocomplete()}
            </Grid>
            <Grid item xs={6} style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isContact}
                    onChange={() => {
                      setIsContact(!isContact)
                      setDirty(true)
                    }}
                  />
                }
                label="Is Contact"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isEmail}
                    onChange={() => {
                      setIsEmail(!isEmail)
                      setDirty(true)
                    }}
                  />
                }
                label="Is Email"
              />
            </Grid>

            <Grid item xs={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={handleAdd}
              >
                {editIndex !== null ? 'Update' : 'Add'}
              </Button>
            </Grid>
          </Grid>
        </Card>
        <Box>
          <Paper sx={{ width: '100%', mb: 2, boxShadow: 'none' }}>
            {loading ? (
              <Box style={loader}>
                <CircularProgress />
              </Box>
            ) :
              <DataList
                data={listData}
                deleteRow={deleteKeyContacts}
                editRow={editKeyContacts}
                isDraggable={true}
                onDragEnd={onDragEnd}
                handleViewParticipants={handleViewParticipants}
              />}
          </Paper>
        </Box>
        {openAddParticipantDialog && (
          <UserListDialog
            title={
              'VIEW PARTICIPANTS'
            }
            // addParticipants={addParticipants}
            open={openAddParticipantDialog}
            deleteParticipants={deleteParticipants}
            handleClose={handleCloseViewInstruction}
            users={selectedViewParticipantData}
            isView={true}
            selectAllCheckBox={true}
          />
        )}
        <Box className={classes.buttonContainer}>
          <ButtonContainer
            disableButton={disBtn}
            showLoading={props.showLoading}
            loading={props.showLoading}
            handleClick={handleSubmit}
            handleCancel={handleCancel}
            buttonText={'Submit'}
          />
        </Box>
      </Box>
      {snackBarProps.openSnack && (
        <CustomizedSnackbars
          {...snackBarProps}
          onClose={() =>
            setSnackBarProps({ ...snackBarProps, openSnack: false })
          }></CustomizedSnackbars>
      )}
      <RouterPrompt
        when={dirty}
        title="Leave this page"
        cancelText="Cancel"
        okText="Confirm"
        onOK={() => true}
        onCancel={() => false}
      />
    </Box>

  );
};

export default KeyContacts;